import { useMutation } from '@apollo/client'
import { bfsMutation } from '../../../appsync/graphql/student'
import { mergeBfsDataIntoStudentReg } from '../../../appsync/actions/student'
import { formatAppsyncErrors } from '../../../appsync/utils'

const useStudentBfsMutation = ({ educationPeriod, onCompleted }) => {
  const [ mutate, { data: rawData = {}, called, loading, error: rawError = null }] = useMutation(
    bfsMutation,
    {
      onCompleted,
      update(cache, { data: { saveBfsInfo } }) {
        mergeBfsDataIntoStudentReg({
          cache,
          data: saveBfsInfo,
          educationPeriod,
        })
      },
    }
  )

  const data = rawData?.saveBfsInfo ?? {}
  const error = rawError ? formatAppsyncErrors(rawError) : null

  return {
    mutate, data, called, loading, error,
  }
}

export default useStudentBfsMutation
